export default "__VITE_ASSET__LQMmzCh4__"